var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48097740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39 23.8496C39 15.0106 31.833 7.84961 23 7.84961C14.161 7.84961 7 15.0106 7 23.8496C7 31.8336 12.849 38.4536 20.5 39.6526V28.4756H16.437V23.8506H20.5V20.3236C20.5 16.3146 22.885 14.1006 26.541 14.1006C28.292 14.1006 30.125 14.4126 30.125 14.4126V18.3496H28.104C26.12 18.3496 25.5 19.5846 25.5 20.8496V23.8496H29.937L29.224 28.4746H25.5V39.6516C33.145 38.4526 39 31.8326 39 23.8486V23.8496Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c009bdcc95abf39b05ff24fdb13a15ea.svg";
export { ForwardRef as ReactComponent };